import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import InfiniteCalendar, {
    Calendar,
    withRange,
} from 'react-infinite-calendar';

import 'react-infinite-calendar/styles.css';

import AddEvento from './CalendarioContent/AddEvento';

class Calendario extends Component {
    state = {
        selectDay: "",
    }
    
    diaSelect = (rango) => {

        let dateIn = new Date(rango.start);
        let dayIn = dateIn.getDate();
        let monthIn = dateIn.getMonth() + 1;
        let yearIn = dateIn.getFullYear();

        if (dayIn < 10) dayIn = `0${dayIn}`
        if (monthIn < 10) monthIn = `0${monthIn}`

        let diaInF = `${dayIn}/${monthIn}/${yearIn}`;

        let dateOut = new Date(rango.end);
        let dayOut = dateOut.getDate();
        let monthOut = dateOut.getMonth() + 1;
        let yearOut = dateOut.getFullYear();

        if (dayOut < 10) dayOut = `0${dayOut}`
        if (monthOut < 10) monthOut = `0${monthOut}`
        
        let diaOutF = `${dayOut}/${monthOut}/${yearOut}`;

        document.getElementById("fechaIn").value = diaInF;
        document.getElementById("fechaOut").value = diaOutF;
    }

    calendario = () => (
        <InfiniteCalendar
            Component={withRange(Calendar)}
            width="100%"
            height={250}
            disabledDays={[0,6]}
            locale={{
                locale: require('date-fns/locale/es'),
                headerFormat: 'dd D MMM',
                weekdays: ["Dom", "Lun", "Mar", "Mier", "Jue", "Vie", "Sab"],
                todayLabel: {
                    long: 'Hoy',
                    short: 'Hoy'
                }
            }}
            theme={{
                selectionColor: 'rgb(50, 165, 165)',
                textColor: {
                    default: '#333',
                    active: '#FFF'
                },
                weekdayColor: 'rgb(22, 115, 115)',
                headerColor: 'rgb(50, 165, 165)',
                floatingNav: {
                    background: 'rgba(16, 39, 39, 0.96)',
                    color: '#FFF',
                    chevron: 'rgba(255, 255, 255, 0)'
                }
            }}
            onSelect={(date) => { this.diaSelect(date) }}
        />
    )

    render() {
        return (
            <Row>
                <Col md={4}>
                    {this.calendario()}
                    <div align="center" className="custom-mt-10 text-muted" style={{fontSize: 10}}>Si deseas seleccionar <strong>un solo día</strong> haz doble click sobre el</div>
                </Col>
                <Col md={8}>
                    <AddEvento />
                </Col>
            </Row>  
        );
    }
}
 
export default Calendario;


// WEBPACK FOOTER //
// ./src/views/Academicos/Calendario.jsx